<section class="perfil-panel" [class.figma]="!esRolInstitucional">
  <ng-container *ngIf="esRolInstitucional; else filtrosPostulante">
    <div class="institucional-toolbar">
      <div class="institucional-toolbar-top">
        <div class="advanced-grid advanced-grid-institucional">
          <div class="advanced-field advanced-field-search">
            <label>B&uacute;squeda general (min 4)</label>
            <input
              type="text"
              placeholder="Nombre o ID"
              [(ngModel)]="busquedaGeneral"
            />
          </div>
          <div class="busqueda-general-wrap">
            <button type="button" class="btn-search" (click)="ejecutarBusquedaInstitucional()">Buscar</button>
            <button type="button" class="btn-search btn-clear-search" (click)="limpiarBusquedaYFiltrosInstitucionales()">Limpiar</button>
          </div>
        </div>

        <div class="advanced-row institucional-toolbar-sort">
          <div class="sort">
            <select id="ordenarPorCampo" [(ngModel)]="ordenarPor" (change)="aplicarFiltros()">
              <option value="fecha_inicio">Fecha de inicio</option>
              <option value="fecha_termino">Fecha de t&eacute;rmino</option>
            </select>
            <select id="ordenPostulaciones" [(ngModel)]="ordenSeleccionado" (change)="aplicarFiltros()">
              <option value="desc">Desc</option>
              <option value="asc">Asc</option>
            </select>
          </div>
        </div>
      </div>

      <div class="filters-grid filters-grid-institucional">
        <div class="filter-field">
          <label>ID postulaci&oacute;n</label>
          <select [(ngModel)]="idPostulacionBusqueda" (change)="aplicarFiltros()">
            <option value="Todos">Todos</option>
            <option *ngFor="let id of idsPostulacion" [value]="id">{{ id }}</option>
          </select>
        </div>

        <div class="filter-field">
          <label>Subdirecci&oacute;n</label>
          <select [(ngModel)]="subdireccionSeleccionada" (change)="aplicarFiltros()">
            <option value="Todas">Todas</option>
            <option *ngFor="let subdireccion of subdirecciones" [value]="subdireccion">{{ subdireccion }}</option>
          </select>
        </div>

        <div class="filter-field">
          <label>Estado postulaci&oacute;n</label>
          <select [(ngModel)]="estadoSeleccionado" (change)="aplicarFiltros()">
            <option value="Todos">Todos</option>
            <option *ngFor="let estado of estadosPostulacion" [value]="estado">{{ estado }}</option>
          </select>
        </div>
        <div class="filter-field">
          <label>A&ntilde;o</label>
          <select [(ngModel)]="anioSeleccionado" (change)="aplicarFiltros()">
            <option value="Todos">Todos</option>
            <option *ngFor="let anio of anios" [value]="anio">{{ anio }}</option>
          </select>
        </div>

        <div class="filter-field">
          <label>Folio</label>
          <select [(ngModel)]="folioBusqueda" (change)="aplicarFiltros()">
            <option value="Todos">Todos</option>
            <option *ngFor="let folio of foliosDisponibles" [value]="folio">{{ folio }}</option>
          </select>
        </div>

        <div class="filter-field">
          <label>Proyecto</label>
          <select [(ngModel)]="proyectoBusqueda" (change)="aplicarFiltros()">
            <option value="Todos">Todos</option>
            <option *ngFor="let proyecto of proyectosDisponibles" [value]="proyecto">{{ proyecto }}</option>
          </select>
        </div>
        <div class="filter-field">
          <label>Departamento / Facultad</label>
          <select [(ngModel)]="departamentoBusqueda" (change)="aplicarFiltros()">
            <option value="Todos">Todos</option>
            <option *ngFor="let dpto of departamentosDisponibles" [value]="dpto">{{ dpto }}</option>
          </select>
        </div>
      </div>
    </div>
  </ng-container>

  <ng-template #filtrosPostulante>
    <div class="filtros-figma">
      <label class="filter-field filtro-concurso">
        <span class="filter-label">Concurso</span>
        <select [(ngModel)]="concursoSeleccionado" (change)="aplicarFiltros()">
          <option value="Todos">Seleccionar</option>
          <option *ngFor="let concurso of concursos" [value]="concurso">{{ concurso }}</option>
        </select>
      </label>
      <label class="filter-field filtro-subdireccion">
        <span class="filter-label">Subdirección</span>
        <select [(ngModel)]="subdireccionSeleccionada" (change)="aplicarFiltros()">
          <option value="Todas">Seleccionar</option>
          <option *ngFor="let subdireccion of subdirecciones" [value]="subdireccion">{{ subdireccion }}</option>
        </select>
      </label>
      <label class="filter-field filtro-estado">
        <span class="filter-label">Estado postulación</span>
        <select [(ngModel)]="estadoSeleccionado" (change)="aplicarFiltros()">
          <option value="Todos">Seleccionar</option>
          <option *ngFor="let estado of estadosPostulacion" [value]="estado">{{ estado }}</option>
        </select>
      </label>
      <label class="filter-field filtro-id">
        <span class="filter-label">ID postulación</span>
        <input
          type="text"
          placeholder="Texto de ejemplo"
          [(ngModel)]="idPostulacionBusqueda"
          (ngModelChange)="aplicarFiltros()"
        />
      </label>
      <label class="filter-field filtro-buscar">
        <span class="filter-label">Buscar por nombre / título</span>
        <span class="search-input">
          <lucide-angular name="search" aria-hidden="true"></lucide-angular>
          <input
            type="text"
            placeholder="Texto de ejemplo"
            [(ngModel)]="proyectoBusqueda"
            (ngModelChange)="aplicarFiltros()"
          />
        </span>
      </label>
    </div>
  </ng-template>

  <p class="search-warning" *ngIf="mensajeBusquedaMinima">{{ mensajeBusquedaMinima }}</p>

  <div class="tags" *ngIf="esRolInstitucional && filtrosActivos.length > 0">
    <span *ngFor="let filtro of filtrosActivos">
      {{ filtro.label }}
      <button type="button" class="tag-remove" (click)="limpiarFiltro(filtro.key)" aria-label="Quitar filtro">
        <lucide-angular name="x"></lucide-angular>
      </button>
    </span>
  </div>

  <div class="table-wrap" *ngIf="postulaciones.length > 0; else sinResultadosTpl" [class.table-wrap-figma]="!esRolInstitucional">
    <table class="table" [class.table-figma]="!esRolInstitucional">
      <thead>
        <tr *ngIf="esRolInstitucional; else encabezadoFigma">
          <th class="col-id-postulacion">ID Postulaci&oacute;n</th>
          <th class="col-concurso">Concurso</th>
          <th class="col-id-proyecto">ID Proyecto</th>
          <th class="col-subdireccion">Subdirecci&oacute;n</th>
          <th class="col-folio">Folio</th>
          <th class="col-proyecto">Proyecto</th>
          <th class="col-estado">Estado postulaci&oacute;n</th>
          <th class="col-acciones">Acciones</th>
        </tr>
        <ng-template #encabezadoFigma>
          <tr>
            <th>Convocatoria</th>
            <th>Línea</th>
            <th>ID Postulación</th>
            <th>Folio</th>
            <th>Avance</th>
            <th>Fecha de cierre</th>
            <th>Estado</th>
            <th class="col-acciones">Acciones</th>
          </tr>
        </ng-template>
      </thead>
      <tbody>
        <ng-container *ngIf="esRolInstitucional; else filasFigma">
          <tr *ngFor="let item of postulacionesPaginadas">
            <td class="col-id-postulacion">{{ item.idPostulacion }}</td>
            <td class="col-concurso">{{ item.concurso }}</td>
            <td class="col-id-proyecto">{{ obtenerIdProyecto(item) }}</td>
            <td class="col-subdireccion">{{ item.subdireccion }}</td>
            <td class="col-folio">
              <a *ngIf="mostrarFolio(item); else sinFolio" [href]="item.trackingUrl" target="_blank" rel="noopener noreferrer" class="folio-link">
                {{ item.folio }}
              </a>
              <ng-template #sinFolio>
                <span class="folio-empty">-</span>
              </ng-template>
            </td>
            <td class="col-proyecto">{{ item.nombreProyecto }}</td>
            <td class="col-estado">
              <span class="badge" [ngClass]="claseEstadoPostulacion(item.estadoPostulacion)">
                {{ estadoCompleto(item) }}
              </span>
            </td>
            <td class="col-acciones actions">
              <div class="actions-wrap">
                <ng-container *ngIf="!sinAcciones(item); else sinAccionesTpl">
                  <button type="button" class="icon-action" (click)="accederFormulario(item)" aria-label="Ver postulación">
                    <lucide-angular name="eye"></lucide-angular>
                  </button>
                  <ng-container *ngIf="puedeEliminar(item)">
                    <button type="button" class="icon-action" (click)="abrirModalEliminar(item)" aria-label="Eliminar postulación">
                      <lucide-angular name="trash-2"></lucide-angular>
                    </button>
                  </ng-container>
                </ng-container>
                <ng-template #sinAccionesTpl>
                  <span class="no-actions">Solo visualizaci&oacute;n</span>
                </ng-template>
              </div>
            </td>
          </tr>
        </ng-container>
        <ng-template #filasFigma>
          <tr *ngFor="let item of postulacionesPaginadas">
            <td>
              <div class="convocatoria">
                <span>{{ item.concurso }}</span>
                <small>{{ item.anio }}</small>
              </div>
            </td>
            <td>{{ lineaDePostulacion(item) }}</td>
            <td>{{ item.idPostulacion }}</td>
            <td>{{ folioDePostulacion(item) }}</td>
            <td>{{ avanceDePostulacion(item) }}</td>
            <td>
              <div class="fecha-cierre">
                <span>{{ fechaCierreDia(item) }}</span>
                <small *ngIf="fechaCierreHora(item)">{{ fechaCierreHora(item) }}</small>
              </div>
            </td>
            <td class="col-estado">
              <span class="badge" [ngClass]="claseEstadoPostulacion(item.estadoPostulacion)">
                {{ estadoCompleto(item) }}
              </span>
            </td>
            <td class="col-acciones actions">
              <div class="actions-wrap" [class.actions-box]="mostrarLapiz(item) || puedeEliminar(item)">
                <button
                  *ngIf="mostrarLapiz(item)"
                  type="button"
                  class="icon-action"
                  (click)="accederFormulario(item)"
                  aria-label="Editar postulación"
                >
                  <lucide-angular name="pencil"></lucide-angular>
                </button>
                <button
                  *ngIf="puedeEliminar(item)"
                  type="button"
                  class="icon-action"
                  (click)="abrirModalEliminar(item)"
                  aria-label="Eliminar postulación"
                >
                  <lucide-angular name="trash-2"></lucide-angular>
                </button>
                <button
                  *ngIf="mostrarOjo(item)"
                  type="button"
                  class="icon-action"
                  (click)="accederFormulario(item)"
                  aria-label="Ver postulación"
                >
                  <lucide-angular name="eye"></lucide-angular>
                </button>
                <button
                  *ngIf="mostrarDescarga(item)"
                  type="button"
                  class="icon-action"
                  (click)="descargarPostulacion(item)"
                  aria-label="Descargar postulación"
                >
                  <lucide-angular name="download"></lucide-angular>
                </button>
              </div>
            </td>
          </tr>
        </ng-template>
      </tbody>
    </table>
  </div>

  <nav class="pager-figma" *ngIf="!esRolInstitucional && postulaciones.length > 0" aria-label="Paginación">
    <button type="button" class="pager-figma-btn" (click)="cambiarPagina(paginaActual - 1)" [disabled]="paginaActual <= 1" aria-label="Página anterior">
      <lucide-angular name="chevron-left"></lucide-angular>
    </button>
    <button
      type="button"
      class="pager-figma-num"
      *ngFor="let pagina of paginasVisibles"
      [class.active]="pagina === paginaActual"
      (click)="cambiarPagina(pagina)"
    >
      {{ pagina }}
    </button>
    <button type="button" class="pager-figma-btn" (click)="cambiarPagina(paginaActual + 1)" [disabled]="paginaActual >= totalPaginas" aria-label="Página siguiente">
      <lucide-angular name="chevron-right"></lucide-angular>
    </button>
  </nav>

  <app-table-pagination
    *ngIf="esRolInstitucional"
    [page]="paginaActual"
    [pageSize]="cantidadPorPagina"
    [totalItems]="postulaciones.length"
    itemLabel="postulaciones"
    [pageSizeOptions]="opcionesCantidad"
    (pageChange)="cambiarPagina($event)"
    (pageSizeChange)="cambiarCantidadDesdePaginador($event)"
  ></app-table-pagination>

  <div class="download-row" *ngIf="esRolInstitucional && postulaciones.length > 0">
    <button type="button" class="btn-download" (click)="descargarPostulacionesFiltradas()">Descargar</button>
  </div>

  <ng-template #sinResultadosTpl>
    <app-empty-filter-state></app-empty-filter-state>
  </ng-template>

  <p class="search-warning" *ngIf="mensajeAccion">{{ mensajeAccion }}</p>
</section>

<div class="modal-backdrop" *ngIf="modalEliminarVisible">
  <div class="modal-card" role="dialog" aria-modal="true" aria-label="Confirmaci&oacute;n de eliminaci&oacute;n">
    <h3>Eliminar postulaci&oacute;n</h3>
    <p>
      &iquest;Est&aacute;s seguro que deseas eliminar la postulaci&oacute;n
      <strong>{{ postulacionAEliminar?.idPostulacion }}</strong>?
    </p>
    <div class="modal-actions">
      <button type="button" class="btn-secondary" (click)="cerrarModalEliminar()">Cerrar</button>
      <button type="button" class="btn-danger" (click)="confirmarEliminar()">Eliminar</button>
    </div>
  </div>
</div>
